import { createApi, createBaseQuery } from '@adv-frontend/modules-query';
import { apiFormDataRequest, apiV1Request } from '#shared/api/requests';
import {
    getOpenApiGetImportVariantsInProductListStatusUrl,
    getOpenApiImportVariantsInProductListUrl,
    OpenApiGetImportVariantsInProductListStatusMethod,
    type OpenApiGetImportVariantsInProductListStatusPathParameters,
    type OpenApiGetImportVariantsInProductListStatusResponseSuccess,
    OpenApiImportVariantsInProductListMethod,
    type OpenApiImportVariantsInProductListPathParameters,
    type OpenApiImportVariantsInProductListResponseSuccess,
} from '#shared/api/schema';

const productListApi = createApi({
    name: 'entities/product/api/productList',
    tagTypes: [],
    baseQuery: createBaseQuery(apiV1Request),
    endpoints: (builder) => {
        return {
            getLastImportStatus: builder.query<
                OpenApiGetImportVariantsInProductListStatusResponseSuccess,
                OpenApiGetImportVariantsInProductListStatusPathParameters
            >({
                query: (params) => {
                    return {
                        url: getOpenApiGetImportVariantsInProductListStatusUrl(params),
                        method: OpenApiGetImportVariantsInProductListStatusMethod,
                    };
                },
            }),
            importFromExcelAsync: builder.mutation<
                OpenApiImportVariantsInProductListResponseSuccess,
                { payload: FormData; params: OpenApiImportVariantsInProductListPathParameters }
            >({
                queryFn: async ({ payload, params }, api, extraOptions) => {
                    const formDataBaseQuery = createBaseQuery(apiFormDataRequest);

                    const { error } = await formDataBaseQuery(
                        {
                            url: getOpenApiImportVariantsInProductListUrl(params),
                            method: OpenApiImportVariantsInProductListMethod,
                            body: payload,
                        },
                        api,
                        extraOptions
                    );

                    if (error) {
                        return { error };
                    }

                    return { data: undefined };
                },
            }),
        };
    },
});

export const useLazyGetLastProductListImportStatus = productListApi.useLazyGetLastImportStatusQuery;
export const importVariantsFromProductList = productListApi.endpoints.importFromExcelAsync.mutate;
